import classNames from 'helpers/class-names'
import { FC, HTMLAttributes, useEffect, useRef, useState } from 'react'

interface Props extends HTMLAttributes<HTMLTableCellElement> {}

export const TableCell: FC<Props> = ({ children, ...props }) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isTruncated, setIsTruncated] = useState(false)
  const [isFirstCell, setIsFirstCell] = useState(false)
  const spanRef = useRef<HTMLSpanElement>(null)
  const tdRef = useRef<HTMLTableCellElement>(null)

  useEffect(() => {
    const td = tdRef.current
    if (td) {
      setIsFirstCell(td.cellIndex === 0)
    }
  }, [])

  useEffect(() => {
    const el = spanRef.current
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight)
    }
  }, [children])

  return (
    <td
      {...props}
      ref={tdRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={classNames(
        'relative h-10 px-2 align-middle leading-5 first-of-type:px-3 group-hover:bg-gray-50 group-data-[selected=true]:bg-gray-50 group-data-[selected=true]:text-gray-500',
        props.className,
      )}>
      {isFirstCell && (
        <div
          className="absolute left-0 top-0 hidden h-10 w-1 bg-info group-data-[selected=true]:block"
          style={{ boxShadow: '0 1px 0 #6bb0b3' }}
        />
      )}
      <span
        ref={spanRef}
        className={classNames({
          'line-clamp-1 break-words': !(isHovered && isTruncated),
          'absolute left-0 top-0 z-10 m-1 mr-4 mt-2 overflow-visible rounded-bl-md rounded-br-md border border-t-0 bg-gray-50 p-1 pt-0 shadow-sm':
            isHovered && isTruncated,
        })}>
        {typeof children === 'function' ? children({ isHovered }) : children}
      </span>
    </td>
  )
}
